import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ing_energias_reno',
  templateUrl: './ing_energias_reno.component.html',
  styleUrls: ['./ing_energias_reno.component.css']
})
export class Ing_energias_renoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
